<template>
    <div>
        

        <div class="content-header row">
            <div class="content-header-left col-md-9 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">Requêtes API</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-body">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center row">
                                <div class="col-sm-1 col-md-1">
                                    <select style="width:60px !important" class="form-control" v-model="tableData.length" @change="changePerPage()">
                                        <option v-for="(records, index) in perPage" :key="index" :value="records">{{records}}</option>
                                    </select>
                                </div>
                                <div id="search_zone" class="mb-2 text-right">
                                    <input class="form-control" type="text" v-model="tableData.search"
                                    @input="getSearch()">
                                </div>
                            </div>
                            <v-table :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
                                <tbody>
                                    <tr class="pointer" v-for="(request, key) in requests" :key="key">
                                        <td>{{ request.request_name }}</td>
                                        <td>{{request.client.name}}</td>
                                        <td>{{request.http_method}}</td>
                                        <td>{{request.endpoint}} </td>
                                        <td>{{request.source}} </td>
                                        <td>{{formatDate(request.timestamp)}} </td>
                                    </tr>
                                </tbody>
                            </v-table>
                            <v-paginate :links="links" :navigationFunction="navigation"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {api, _buildQuery, scheme } from "../../../../helpers/shared";
    import vTable from '../../../../components/vTable/vTable.vue';
    import vPaginate from '../../../../components/vTable/vPaginate1.vue';
    import customModal from '../../../../components/modal/customModal.vue';
    import axios from 'axios';
    import moment from "moment";

    const default_data = {
        name: ''
    };
    var $this;
    export default {
        name: "index",
        components:{
            vTable, vPaginate, customModal
        },
        props: ['self'],
        data() {
            let sortOrders = {};
            let columns = [
                {width: '33%', label: 'Nom', name: 'request_name' },
                {width: '33%', label: 'Client', name: 'client.name' },
                {width: '33%', label: 'Méthode  ', name: 'http_method'},
                {width: '33%', label: 'Terminaison', name: 'endpoint'},
                {width: '33%', label: 'Source', name: 'source'},
                {width: '33%', label: 'Date', name: 'timestamp'},
                // {width: '33%', label: 'Actions', name: 'action'},
            ];
            columns.forEach((column) => {
                sortOrders[column.name] = -1;
            });
            return {
                links: [],
                requests: [],
                columns: columns,
                sortKey: 'customer',
                sortOrders: sortOrders,
                perPage: ['10', '20', '30'],
                tableData: {
                    page: 0,
                    length: 10,
                    search: '',
                    column: 0,
                    dir: 'desc',
                    profile: '',
                },
                form:{
                    name: '',
                },
                errors: [],
                loading: false,
                index: null,
            }
        },
        created(){
            $this = this
        },
        mounted(){
            this.getRequests();
        },
        methods:{
            
            changeRole(){
                this.changePerPage();
            },
            changePerPage(url = 'administration/api/requests'){
                this.tableData.page = 1;
                axios.get(api(url), {params: this.tableData})
                .then(response => {
                    let content = response.data;
                    this.requests = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
            },
            getNext(url){
                this.tableData.page ++;
                axios.get(url, {params: this.tableData})
                .then(response => {
                    let content = response.data;
                    this.requests = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
            },
            getPrev(url){
                this.tableData.page --;
                axios.get(url, {params: this.tableData})
                .then(response => {
                    let content = response.data;
                    this.requests = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
            },
            getRequests(url = 'administration/api/requests') {
                let loader = this.$loading.show({
                    container: null,
                    canCancel: false,
                    color: "#4B4B4B",
                    backgroundColor: "#4B4B4B",
                    height: 35,
                    width: 35,
                    loader: "bars",
                    opacity: 0.3,
                });
                this.tableData.page++;
                axios.get(api(url), {params: this.tableData})
                    .then(response => {
                        loader.hide();
                        let content = response.data;
                        this.requests = content.data;
                        this.configPagination(content);
                    })
                    .catch(errors => {
                        console.log(errors);
                    });
            },
            configPagination(data) {
                this.links = data.links;
            },
            sortBy(key) {
                this.sortKey = key;
                this.sortOrders[key] = this.sortOrders[key] * -1;
                this.tableData.column = this.getIndex(this.columns, 'name', key);
                this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
                this.getRequests();
            },
            getIndex(array, key, value) {
                return array.findIndex(i => i[key] == value)
            },
            getSearch(){
                this.changePerPage()
            },
            formatDate(date) {
                return moment(date).format("DD-MM-YYYY HH:mm");
            },



            transformErrors(errors) {
                let transformed = {};
                for (let key in errors) {
                    if (errors.hasOwnProperty(key)) {
                    let keys = key.split('.');
                    if (keys.length === 1) {
                        transformed[keys[0]] = errors[key];
                    } else {
                        if (!transformed[keys[0]]) {
                        transformed[keys[0]] = {};
                        }
                        transformed[keys[0]][keys[1]] = errors[key];
                    }
                    }
                }
                return transformed;
            },



            navigation(page) {
                this.tableData.page = page;
                axios.get(api('administration/api/requests'), {params: this.tableData})
                    .then(response => {
                        let content = response.data;
                        this.requests = content.data;
                        this.configPagination(content);
                    })
                    .catch(errors => {
                        console.log(errors);
                    });
            },
        }
    }
</script>

<style scoped>
    #search_zone{
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 5px;
    }
</style>
